const Constants = {
    Permission: {
        Consultant: "Consultant",
        CompanyAdmin: "Administrator",
        FunctionAdmin: "Function Admin",
        TeamAdmin: "Coach",
        User: "Team Member",
    },
    AWS: {
        region: 'us-east-1',
        accessKeyId: 'AKIASXFQ2SFJR3IIFTWN',
        secretAccessKey: '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'
    }
}

export default Constants;